import * as React from "react";

type Props = {
  children: React.ReactNode;
  disabled?: boolean;
};

export function swallowEvent(event) {
  event.stopPropagation();
}

export default function EventBoundary(props: Props) {
  return (
    <div
      onKeyDown={props.disabled ? undefined : swallowEvent}
      onMouseDown={props.disabled ? undefined : swallowEvent}
      onClick={props.disabled ? undefined : swallowEvent}
    >
      {props.children}
    </div>
  );
}
